/* eslint-env browser */
/* eslint-disable no-underscore-dangle */

import { createStore, applyMiddleware, compose } from 'redux';
import { reduxReactRouter } from 'redux-router';
import { createHistory, useBasename } from 'history';
import thunk from 'redux-thunk';
// import { composeWithDevTools } from 'redux-devtools-extension';

import routes from '../routes';
import api from '../middleware/api';
import rootReducer from '../reducers';

let middleware;
let historyConfig;

if (window.APP_ROOT && window.APP_ROOT !== '/') {
  historyConfig = { basename: window.APP_ROOT };
}

const history = useBasename(createHistory)(historyConfig || {});

middleware = [applyMiddleware(thunk, api), reduxReactRouter({ routes, history })];

if (process.env.NODE_ENV !== 'production') {
  /* eslint global-require: 0 */
  const { devTools } = require('redux-devtools');
  const createLogger = require('redux-logger');

  middleware = [...middleware, applyMiddleware(createLogger({
    collapsed: () => true,
  })), devTools()];
}

if (process.env.NODE_ENV !== 'production' && typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  middleware.push(window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__());
}

const finalCreateStore = compose(...middleware)(createStore);

export default function configureStore(initialState) {
  return finalCreateStore(rootReducer, initialState);
}



// WEBPACK FOOTER //
// ./src/app/store/configureStore.js